import { Link } from 'react-router-dom';

export default function InfoSection() {
  return (
    <section className="relative w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <div>
            <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold tracking-wide mb-4">
              About
            </span>
            <h2 className="text-3xl md:text-4xl font-heading font-semibold text-foreground-900 mb-5 leading-tight">
              What Is <span className="italic">BaseTao Spreadsheet</span>?
            </h2>
            <div className="space-y-4 text-foreground-600 leading-relaxed">
              <p>
                A <strong>BaseTao Spreadsheet</strong> is the essential organizational tool that experienced shoppers use to track every detail of their purchasing journey. When you shop through BaseTao, you are browsing thousands of products across multiple Chinese marketplaces — and without a structured system, it is easy to lose track of orders, overspend, or miss critical details about your items.
              </p>
              <p>
                Think of a BaseTao Spreadsheet as your personal command center. It centralizes product URLs, pricing information, seller details, warehouse status, and shipping costs all in one accessible place. Rather than juggling browser bookmarks, scattered notes, and email confirmations, you have a single source of truth that keeps your shopping organized and stress-free.
              </p>
              <p>
                Whether you are a first-time user placing your initial order, or a seasoned shopper managing complex multi-vendor hauls, a well-maintained BaseTao Spreadsheet transforms chaos into clarity — saving you time, money, and frustration at every step of the process.
              </p>
            </div>
            <div className="mt-6">
              <Link
                to="/article/basetao-spreadsheet-guide"
                className="whitespace-nowrap inline-flex items-center gap-2 text-primary-600 hover:text-primary-700 font-semibold text-sm transition-colors duration-200 cursor-pointer"
              >
                Learn More About BaseTao Spreadsheet
                <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
              </Link>
            </div>
          </div>

          <div className="relative">
            <div className="rounded-xl overflow-hidden aspect-[4/3]">
              <img
                src="https://readdy.ai/api/search-image?query=A%20bright%20modern%20Scandinavian%20home%20office%20desk%20with%20an%20open%20laptop%20displaying%20a%20colorful%20spreadsheet%2C%20fashion%20accessories%20and%20fabric%20swatches%20arranged%20beside%20the%20computer%2C%20morning%20sunlight%20streaming%20through%20a%20nearby%20window%2C%20warm%20neutral%20beige%20and%20cream%20tones%2C%20editorial%20lifestyle%20photography%20with%20clean%20composition&width=800&height=600&seq=info-section-workspace&orientation=landscape"
                alt="BaseTao Spreadsheet workspace with laptop and organized desk setup"
                title="BaseTao Spreadsheet Organization Workspace"
                className="w-full h-full object-cover object-top rounded-xl"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}